import React from 'react';
import { connect } from 'react-redux';

import MainWindow from '../Wrappers/MainWindow';
import Frame from '../Wrappers/Frame';
import BillingIntro from './BillingIntro';
import AddCard from './AddCard';
import BillingPage from './BillingPage';
import AddBankAccount from './AddBankAccount';
import BillingError from './BillingError';
import { Col, Row } from '../Grid';

interface Props {
  customer: Customer;
  child: string;
  popup?: boolean;
}
interface State {}

class DesktopPage extends React.Component<Props, State> {
  components = {
    intro: <BillingIntro desktop={true} />,
    methods: <BillingPage desktop={true} popup={this.props.popup} />,
    card: <AddCard desktop={true} />,
    bankAccount: <AddBankAccount />,
    error: <BillingError desktop={true} />,
  };

  titles = {
    intro: 'Plan + Payment',
    methods: 'Plan + Accounting: Payment Method',
    card: 'Plan + Accounting: Add Card',
    error: 'Error',
  };

  render() {
    document.title = `Billing • Neoncoat Brands Tool`;

    return (
      <MainWindow page="billing">
        <Row>
          <Col size="9">
            <Frame title={this.titles[this.props.child]} fullHeight={true}>
              {this.components[this.props.child]}
            </Frame>
          </Col>
          <Col size="3" />
        </Row>
      </MainWindow>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    customer: state.billing.customer,
  };
};

export default connect(mapStateToProps)(DesktopPage);
